<div class="cover-wrap">
    <img class="cover-wrap__cover" [src]="data.cover" alt="Cover"/>
    <button aria-label="Button" class="cover-wrap__button hidden"></button>
    <button aria-label="Button" class="cover-wrap__button" mat-icon-button aria-label="Close window" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>